import { render, staticRenderFns } from "./OutputDataCollection.vue?vue&type=template&id=06de8196&"
import script from "./OutputDataCollection.vue?vue&type=script&lang=js&"
export * from "./OutputDataCollection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports